export const quantumPageSV = {
  "seo": {
    "title": "Suveräna LLM & Kvant-AI | pAIoneer Labs GmbH",
    "description": "Vårt mål från Tyskland: att under Veridion ('AI utvecklar AI vidare') utveckla kompakta språkmodeller och Quantum Transformers som i framtiden kommer att konkurrera med de stora modellerna från USA och Kina."
  },
  "hero": {
    "kicker": "Made in Germany · AI utvecklar AI",
    "title": "Suveräna LLM & Kvant-AI",
    "claim": "Vårt mål från Tyskland: att utveckla egna språkmodeller och Quantum Transformers som i framtiden kommer att ta upp kampen mot de stora modellerna från USA och Kina.",
    "subtitle": "I verkliga företagsprojekt har de hittillsvarande europeiska ansatserna — de tyska modellerna från Aleph Alpha (som Kolibri), de franska modellerna kring Mistral, EuroLLM och särskilt schweiziska Apertus — utvärderats mot faktiska verksamhetsproblem. Ingen av dem uppfyller kraven i företag. Därför tar vår AI under [Veridion](veridion) (”AI utvecklar AI vidare”) nästa steg: den utforskar och utvecklar vägen till kompakta språkmodeller Made in Germany som kommer att vara betydligt starkare än de franska modellerna, och driver som andra tyngdpunkt egna Quantum Transformers.",
    "cta": "Boka ett samtal"
  },
  "pillars": {
    "title": "Vad vår AI arbetar med",
    "subtitle": "Två forskningsområden där våra digitala medarbetare utformar nya arkitekturer, prövar dem i simulator och bygger upp dem steg för steg.",
    "items": [
      {
        "title": "Vad en språkmodell måste klara i vardagen",
        "description": "I skarp drift räknas flerstegs logisk slutledning, pålitlig verktygsanvändning över långa arbetskedjor, ren mjukvaruutveckling och felfria kontorsprocesser. Mot detta mäter vi varje arkitektur från start."
      },
      {
        "title": "Kompakta modeller för egen infrastruktur",
        "description": "I stället för allt större datacenter kommer vårt mål att vara att samla djup slutledningsförmåga i en kompakt modell som företag kan köra helt lokalt på egen hårdvara."
      },
      {
        "title": "Quantum Transformers & Kvant-AI",
        "description": "I vårt andra fokusområde utforskar vi hur transformer-arkitekturer kan förenas med parametriserade kvantkretsar och tensornätverk för att öppna nya modellklasser bortom klassiska nät."
      },
      {
        "title": "Egen Quantum IDE & riktiga kvantprocessorer",
        "description": "I vår egenutvecklade Quantum IDE konstruerar, simulerar och testar våra AI-medarbetare nya kvantkretsar mot klassiska referenser innan de körs på riktig kvanthårdvara."
      }
    ]
  },
  "gate": {
    "title": "Från forskningsläge till ritning",
    "subtitle": "Varje utvecklingssteg vilar på granskad litteratur, vårt företagsminne och mätbara jämförelser.",
    "stages": [
      {
        "step": "Steg 01",
        "title": "Litteraturanalys & företagsminne",
        "description": "Våra AI-medarbetare utvärderar löpande de senaste vetenskapliga arbetena om språkmodells- och kvantarkitekturer och lagrar alla verifierade rön i företagets kunskapsgraf."
      },
      {
        "step": "Steg 02",
        "title": "Träningsplan & kretssimulering",
        "description": "Tillsammans med Produktutveckling formas därigenom den detaljerade träningsplanen för vår framtida språkmodell, samtidigt som nya kvantkretsar prövas i vår Quantum IDE."
      },
      {
        "step": "Steg 03",
        "title": "Vetenskaplig prövning i IDD-processen",
        "description": "Mänskliga fysiker och AI-forskare granskar varje hypotes, mätning och konstruktion genom [Intent-Driven Development](idd) (IDD) som human-in-the-loop och godkänner nästa steg."
      }
    ]
  },
  "stack": {
    "title": "Människa och AI i en gemensam forskningsenhet",
    "subtitle": "Forskning, produktutveckling och vetenskaplig tillsyn griper in i varandra i fasta cykler.",
    "items": [
      {
        "title": "Digitala forskare dygnet runt",
        "description": "Specialiserade AI-medarbetare sköter litteratursökning, matematiska härledningar, kretsdesign och utvärdering dygnet runt."
      },
      {
        "title": "Fysiker i Human-in-the-Loop",
        "description": "Mänskliga forskare anger forskningsriktningen, ifrågasätter antaganden och beslutar om godkännanden, hårdvarukörningar och publikationer."
      },
      {
        "title": "Samspel med Produktutveckling",
        "description": "I nära samspel med vår produktutveckling går hållbara forskningsresultat direkt in i våra verktyg och framtida företagslösningar."
      },
      {
        "title": "Spårbart ända till källan",
        "description": "Varje arkitekturbeslut, varje förkastad variant och varje mätresultat förblir varaktigt dokumenterat och kontrollerbart för både människa och AI."
      }
    ]
  },
  "cta": {
    "title": "Utbyte kring forskning",
    "subtitle": "Vill du utbyta tankar om vår forskning kring suveräna språkmodeller och Quantum Transformers? Skriv till oss.",
    "button": "Skriv ett meddelande"
  }
};
